import gql from 'graphql-tag';

export const COURSE_QUERY = gql`
    query ($courseId: String!) {
        getCourseByIdOrSlug(idOrSlug: $courseId) {
            id
            link
            name
            slug
            tags
            isFree
            coverUrl
            description
            isAllowedToCustomer
            coverMobileUrl
            pricing {
                current
                promotion
            }
            category {
                id
                name
            }
            bonus {
                name
                title
                strategies {
                    id
                    name
                    link
                    tags
                    accessLink
                    coverUrl
                    coverMobileUrl
                    category {
                        id
                        name
                    }
                }
            }
            modules {
                name
                isLocked
                lessons {
                    name
                    videoDistributionUrl
                    description
                    isCompleted
                    resources {
                        url
                        name
                    }
                    cta {
                        link
                        title
                        subtitle
                    }
                }
            }
            progress {
                percent
                totalLessons
                completedLessons
            }
            nextLesson {
                moduleId
                lessonId
            }
            purchase {
                id
                isTrial
            }
        }
    }
`;

export interface ICourseModuleLessonResource {
    url: string;
    name: string;
}

export interface ICourseModuleLessonCTA {
    link: string;
    title: string;
    subtitle: string;
}

export interface ICourseModuleLesson {
    name: string;
    videoUrl: string;
    resources: ICourseModuleLessonResource[];
    description: string;
    isCompleted: boolean;
    videoDistributionUrl: string;
    cta?: ICourseModuleLessonCTA;
}

export interface ICourseModule {
    name: string;
    isLocked: boolean;
    lessons: ICourseModuleLesson[];
    progress: number;
    progressPercent: number;
}

export interface ICourseBonusStrategy {
    id: string;
    name: string;
    link: string;
    tags: string[];
    accessLink: string;
    coverUrl: string;
    coverMobileUrl: string;
    category: {
        id: string;
        name: string;
    };
}

export interface ICourse {
    id: string;
    link: string;
    name: string;
    slug: string;
    description: string;
    coverUrl: string;
    isFree: boolean;
    isAllowedToCustomer: boolean;
    completionTime: string;
    modules: ICourseModule[];
    tags: string[];
    pricing: {
        current: number;
        promotion?: number;
    };
    category: {
        id: string;
        name: string;
    };
    bonus: {
        name: string;
        strategies: ICourseBonusStrategy[];
        title: string;
    };
    progress: {
        value: number;
        percent: number;
        totalLessons: number;
        completedLessons: number;
    };
    purchase: {
        id: string;
        isTrial: boolean;
    };
    nextLesson: {
        moduleId: number;
        lessonId: number;
    };
}
